<template>
  <b-form-group
    label="Tutar"
    label-for="amount"
  >
    <validation-provider
      #default="{ errors }"
      name="Tutar"
      rules="required"
    >
      <b-input-group>
        <cleave
          id="amount"
          v-model="cleaveAmount"
          class="form-control"
          :raw="true"
          :options="options.float"
          placeholder="Tutar"
        />
        <b-input-group-append>
          <currency-select />
        </b-input-group-append>
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import CurrencySelect from '@/views/Admin/Account_activities/Expenses/elements/CurrencySelect.vue'

export default {
  name: 'Amount',
  components: {
    CurrencySelect,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    Cleave,
  },
  data() {
    return {
      required,
      options: {
        float: {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
    cleaveAmount: {
      get() {
        // Backend'den gelen değeri Cleave'in beklediği formata çevir
        if (this.dataItem.amount == null || this.dataItem.amount === '') {
          return null
        }
        // Eğer string ise ve nokta içeriyorsa, virgüle çevir
        const amountStr = String(this.dataItem.amount)
        return amountStr.replace('.', ',')
      },
      set(value) {
        // Cleave'den gelen raw değeri (virgülle) backend formatına (noktayla) çevir
        if (value == null || value === '') {
          this.dataItem.amount = null
        } else {
          const amountStr = String(value)
          this.dataItem.amount = amountStr.replace(',', '.')
        }
      },
    },
  },
  created() {
    localize('tr')
  },
}
</script>
